import { Plugin } from '../models/Plugin'
import { i18n } from '../translations'

export const install: Plugin['fn'] = (app) => {
  app.use(i18n)
}
